import React from 'react';
var ToastContext = React.createContext({
  displayToast: function displayToast() {},
  hideToast: function hideToast() {}
});
export var useToast = function useToast() {
  return React.useContext(ToastContext);
};
export default ToastContext;